<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>Mark excise as unfiled</v-card-title>
      <v-divider/>
      <v-card-text class="pt-4 body-1">
        Are you sure you want to unmark excise as filed?
        <div class="mt-4 warning--text">
          This will remove the book closing date for excise and allow transactions to
          be dated in a previously closed excise period.
          This can result in your records being inconsistent with filed excise returns.
        </div>
        <div class="mt-4" v-if="company.settings.exciseCreateReceipt">
          Note that any CRA payment transaction in QuickBooks Online will <strong>not</strong> be removed by unfiling.
          You will have to manually delete such transactions.
        </div>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn color="error" plain @click="unfile()" :loading="saving">Unfile</v-btn>
        <v-btn color="primary" @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: 'ReportsExciseUnfile',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      show: this.value,
      saving: false,
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    value() {
      this.show = this.value;
    },
  },
  methods: {
    async unfile() {
      this.saving = true;
      const results = await this.$apiCall(`mutation ReportsExciseUnfile {
                                              exciseUnfile
                                            }`,
                                          {});
      this.saving = false;
      if (!results.error) {
        this.company.excisePeriodEnd = results.data.exciseUnfile;
        this.$store.commit('setError', {message:'Excise unfiled',type:'success'});
        this.cancel();
      }
    },
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
  }
}
</script>